module.exports = __webpack_public_path__ + "e783028598586fb0b76c6e7dde461b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/saturna_sustainable_funds.png
// module id = 1912
// module chunks = 0